import { css, cx } from '@onbeam/business-styled-system/css';
import { FAQSectionProps } from './FAQSection.types';
import { text, vstack } from '@onbeam/business-styled-system/patterns';
import { Accordion, AccordionGroup } from '@/components';
import { faqItems } from './FAQSection.data';

export const FAQSection = ({ className, ...props }: FAQSectionProps) => (
  <section
    className={cx(vstack({ align: 'center', gap: '10' }), className)}
    {...props}
  >
    <h2
      className={text({
        style: 'subtitle-lg',
        textAlign: 'center',
      })}
    >
      FAQ.
    </h2>
    <AccordionGroup
      type="multiple"
      className={css({ w: 'full', maxW: '[56.125rem]' })}
    >
      {faqItems.map((item, index) => (
        <Accordion key={index} value={String(index)} title={item.title}>
          {item.description}
        </Accordion>
      ))}
    </AccordionGroup>
  </section>
);
